import React, { FC } from 'react';

import Rating from '../Rating';
import Avatar from '../Avatar';
import { User } from '../../types/api/v4/boats/search';

import styles from './BoatReview.module.scss';
import ReviewDate from '../ReviewDate';

export type BoatReviewProps = {
  date: string;
  author: User;
  rating: number;
  content?: string;
};

const BoatReview: FC<BoatReviewProps> = ({
  author,
  content,
  date,
  rating,
}) => (
  <li className={styles.root}>
    <div className={styles.profile}>
      <Avatar
        user={author}
        size="medium"
      />
      <h5 className={styles.name}>
        {author.first_name}
      </h5>
    </div>
    <div className={styles.content}>
      <Rating
        rating={rating}
        size="tiny"
        feature="listingPage"
      />
      <ReviewDate date={date} className={styles.date} />
      {content && (
        <p className={styles.text}>
          {content}
        </p>
      )}
    </div>
  </li>
);

export default BoatReview;
